import { LOADING } from "../../../constants/constant";
import {
  UPDATE_LISTING_SUCCESS,
  UPDATE_LISTING_FAILED,
  UPDATE_LISTING,
  UPDATE_LISTING_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function updateListingReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case UPDATE_LISTING:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case UPDATE_LISTING_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode === 10) {
        userRes.error = false;
      } else {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
      }
      return userRes;

    case UPDATE_LISTING_FAILED:
      return Object.assign({}, state, action.error);
    
      case UPDATE_LISTING_RESET:
      return initialState

    default:
      return state;
  }
}
